import Title from "antd/lib/typography/Title";

export default function StockLedgerReportTemp(props) {
  const thCss = {
    border: "1px solid black",
    padding: "6px 12px",
    display: "table-cell",
    color: "black",
  };
  const thCssHead = {
    border: "1px solid black",
    padding: "6px 12px",
    display: "table-cell",
    background: "#4561b9",
    color: "white",
    fontWeight: "bold",
  };
  const headRow = {
    display: "table-row",
    fontWeight: "900",
    color: "#ffffff",
  };

  return (
    <div style={{ border: "1px solid gray", padding: 20, width: "100%" }}>
      <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        id="table-to-xls"
      >
        <tr>
          <td colSpan={props.headList?.length || 6}>
            <Title level={4} style={{ textAlign: "center" }}>
              Stock Report: {props.branch} - {props.department}
            </Title>
          </td>
        </tr>

        <tr>
          <td colSpan={props.headList?.length || 6}>
            <Title level={5} style={{ textAlign: "center" }}>
              {props.date}
            </Title>
          </td>
        </tr>

        {props.headList?.length > 0 && (
          <tr style={headRow}>
            {props.headList.map((x) => (
              <td key={x} style={thCssHead}>
                {x}
              </td>
            ))}
          </tr>
        )}

        <tbody>
          {props?.list?.map((y, index) => (
            <tr key={index} style={{ pageBreakInside: "avoid" }}>
              {props.headList?.map((x) => (
                <td key={x} style={thCss}>
                  {y[x]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
